import './Table.scss';

import { any, arrayOf, func, node } from 'prop-types';
import React from 'react';

import BaseTable from './BaseTable';
import TableDownloader from './TableDownloader';

function Table({ data, onDownload, children, ...rest }) {
  if (onDownload || children) {
    return (
      <BaseTable data={data} {...rest}>
        {(state, makeTable) => (
          <div>
            {makeTable()}
            <div className="mt-3 text-right">
              {onDownload && (
                <TableDownloader
                  state={state}
                  onDownload={onDownload}
                  {...rest}
                />
              )}
              {children}
            </div>
          </div>
        )}
      </BaseTable>
    );
  }

  return <BaseTable data={data} {...rest} />;
}

Table.propTypes = {
  data: arrayOf(any).isRequired, // eslint-disable-line react/forbid-prop-types
  onDownload: func,
  children: node,
};

Table.defaultProps = {
  onDownload: undefined,
  children: undefined,
};

export default Table;
